/* eslint-disable import/order */
// eslint-disable-next-line jira/import/no-restricted-import
import { fieldsResource } from '@jira/router-resources__business-fields/src/fieldsResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectThemeResource } from '@jira/router-resources__project-theme/src/projectThemeResource.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const jiraBusinessBoardResources = (): RouteResource[] => [
	...getNavigationResources(),
	projectThemeResource,
	// delete when cleaning up board_harmonisation_m2_filter_refinement
	resourceWithCondition(() => !fg('board_harmonisation_m2_filter_refinement'), fieldsResource),
];
